export default __webpack_public_path__ + "static/OpenSans-Regular-b8cc747a58ffa52b7ff9efa81dee2eb9.ttf";